import React from "react";

import { Grid, Typography } from "@mui/material";

import {
  StandardCheckbox,
  StandardPriceRange,
  StandardTextField,
} from "../../../components/standard-form-fields";

export default () => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6">委託 - 漫畫家</Typography>
    </Grid>
    <StandardTextField
      name="comic.form"
      required
      label="作畫形式"
      placeholder="電繪、手繪等"
      registerProps={{
        required: "請填寫您的作畫形式",
      }}
    />
    <StandardCheckbox
      name="comic.format"
      choices={[
        { name: "long", label: "長篇漫畫" },
        { name: "short", label: "短篇漫畫" },
        { name: "fourgrid", label: "四格漫畫" },
      ]}
      required
      label="漫畫篇幅"
    />
    <StandardCheckbox
      name="comic.colorType"
      choices={[
        { name: "bw", label: "黑白漫畫" },
        { name: "color", label: "彩色漫畫" },
      ]}
      required
      label="色彩類型"
    />
    <StandardTextField
      name="comic.genre"
      required
      label="擅長題材"
      placeholder="奇幻、溫馨、恐怖等"
      registerProps={{
        required: "請填寫您的擅長題材",
      }}
    />
    <StandardTextField
      name="comic.updateInterval"
      required
      label="更新偏好"
      placeholder="日更、週更、月更等"
      registerProps={{
        required: "請填寫您的更新偏好",
      }}
    />
    <StandardPriceRange
      name="comic.price"
      required
      label="商業委託價格範圍"
      registerProps={{
        required: "請提供您可接受的委託價格",
      }}
    />
    <StandardTextField
      name="comic.priceDetails"
      required
      label="商業委託價格詳情"
      placeholder="請註明委託內容及對應的價格（如: 一幅插畫單位角色含背景 2000 HKD 或 三萬字漫畫故事劇本 30000 NTD）"
      registerProps={{
        required: "請提供委託內容及對應的價格",
      }}
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="comic.additionalInfo"
      label="補充說明"
      placeholder="如有任何特別技能、接案經驗或委託相關的注意事項，歡迎在此註明"
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="comic.referenceLink"
      required
      label="作品集 / 網站"
      placeholder="您的作品集 / 網站"
      registerProps={{
        required: "請提供作品樣本供客戶參考",
      }}
    />
  </>
);
